import './ProductQuantity.scss'

import InputNumber from 'rc-input-number'
import {InputNumberProps} from 'rc-input-number/lib/interface'
import React from 'react'
import {style} from '../../../../util/style'
import {Icon} from '../../../ui/Icon'

const styles = style('productquantity')

export const ProductQuantity: React.FC<{
	quantity: number
	setQuantity: (v: number) => void
	min?: number
	max?: number
	disabled?: boolean
	uniqueKey: string
}> = ({
	min = 1,
	quantity,
	setQuantity,
	uniqueKey,
	max = 10000,
	disabled = false
}) => {
	const inputID = 'number-' + uniqueKey
	const inputProps: Partial<InputNumberProps> = {
		min,
		max,
		precision: 0,
		upHandler: <Icon icon="chevronUp" />,
		downHandler: <Icon icon="chevronDown" />,
		prefixCls: styles('input').toString(),
		value: Number(quantity),
		disabled,
		onChange: (v) => setQuantity(Number(v)),
		id: inputID
	}
	return (
		<div className={styles}>
			<label htmlFor={inputID} className={styles('label')}>
				{quantity}
			</label>
			<InputNumber {...inputProps} />
		</div>
	)
}
